module.exports = __webpack_public_path__ + "img/loginPic.6cb86647.png";